import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/apiClient";
import { Navbar } from "../components/Navbar";
import { VideoCard } from "../components/VideoCard";
import { useAuth } from "../context/AuthContext";

export default function Dashboard() {
  const { user } = useAuth();
  const [history, setHistory] = useState([]);

  useEffect(() => {
    api.get("/watch/history").then((r) => setHistory(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#030305]">
      <Navbar />
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-28 md:pt-32 pb-24">
        <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 mb-3">Welcome back, {user?.name}</p>
        <h1 className="font-display text-5xl sm:text-6xl uppercase tracking-tighter mb-12">Continue Watching</h1>

        {history.length === 0 ? (
          <div className="border border-white/10 rounded-sm p-16 text-center" data-testid="empty-history">
            <p className="text-zinc-400 mb-6">You haven't watched anything yet.</p>
            <Link
              to="/channels"
              className="inline-flex bg-[#FF2A2A] hover:bg-[#FF4D4D] text-white px-6 py-3 rounded-sm font-semibold transition-colors"
            >
              Browse Channels
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="history-grid">
            {history.map((v) => (
              <VideoCard key={v.id} video={v} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
